<template>
  <i-select
    multiple
    :value="value"
    :filterable="true"
    :clearable="true"
    :class="{ 'empty-select': is_same }"
    @input="input"
  >
    <i-option v-for="n in all_operators" :key="n.id" :label="n.login" :value="n.id" />
  </i-select>
  <!-- <i-select
    :filterable="true"
    :clearable="true"
    :value="filtered_operators"
    multiple
    @input="input"
  >
    <i-option
      v-for="(item, key) in invisible_operators"
      :key="key - 500"
      :label="item.login"
      :value="item.id"
    />
    <i-option
      v-for="(item, key) in visible_operators"
      :key="key"
      :label="item.login"
      :value="item.id"
    /> 
   </i-select> -->
</template>
<script>
  import isEqual from 'lodash-es/isEqual';

  export default {
    props: {
      value: {
        type: Array,
        default: function () {
          return [];
        }
      },
      filtered_operators: {
        type: [Array, String],
        default: () => []
      },
      all_operators: {
        type: [Array, String],
        default: () => []
      }
    },
    data: () => ({
      operators: [],
      exist_operators: [],
      operators_label: []
    }),
    watch: {
      filtered_operators: {
        handler: function () {
          this.operators_label = this.filtered_operators;
        },
        immediate: true
      }
    },
    computed: {
      is_same() {
        return isEqual(
          this.value,
          this.all_operators.map((i) => i.id)
        );
      }
    },
    methods: {
      input(val) {
        this.operators_label = val;
        this.$emit('input', val);
      }
    }
  };
</script>

<style lang="scss">
  .ivu-select-multiple .ivu-select-item-selected {
    display: none;
  }

  .empty-select {
    .ivu-select-dropdown {
      display: none;
    }
  }
</style>
